import { render, staticRenderFns } from "./ConnectionBanner.vue?vue&type=template&id=2faef044&scoped=true"
import script from "./ConnectionBanner.vue?vue&type=script&lang=js"
export * from "./ConnectionBanner.vue?vue&type=script&lang=js"
import style0 from "./ConnectionBanner.vue?vue&type=style&index=0&id=2faef044&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faef044",
  null
  
)

export default component.exports